module.exports = __webpack_public_path__ + "img/Logo.12395055.jpg";